import { Channel, normalizeChannelStatusValue, ChannelStatus } from "../models/Channel";

export type ChannelStatusPayload = {
  channel?: Partial<Channel> & { code?: string; reason?: string; rawStatus?: string };
  status?: string;
  code?: string;
  reason?: string;
  rawStatus?: string;
  connectedJid?: string;
  connectedPhone?: string;
  sessionId?: string;
  organizationId?: string;
  passkey?: {
    publicKey?: unknown;
  };
  publicKey?: unknown;
};

export const normalizeChannelStatus = (value?: string | null): ChannelStatus | null => {
  return normalizeChannelStatusValue(value);
};

export const resolveChannelStatusPayload = (payload: ChannelStatusPayload | null | undefined) => {
  const channel = payload?.channel;
  const rawStatus = payload?.rawStatus || channel?.rawStatus || payload?.status || channel?.status;
  const status = normalizeChannelStatus(rawStatus);
  const code = payload?.code || channel?.code || null;
  const reason = resolveChannelStatusReason(code, payload?.reason || channel?.reason || null);

  const result: {
    status: ChannelStatus | null;
    rawStatus: string | null;
    code: string | null;
    reason: string | null;
    connectedJid?: string;
    connectedPhone?: string;
  } = {
    status,
    rawStatus: rawStatus || null,
    code,
    reason,
  };
  const connectedJid = payload?.connectedJid || channel?.connectedJid;
  const connectedPhone = payload?.connectedPhone || channel?.connectedPhone;
  if (connectedJid) result.connectedJid = connectedJid;
  if (connectedPhone) result.connectedPhone = connectedPhone;

  return result;
};


export const resolveChannelStatusReason = (code?: string | null, reason?: string | null): string | null => {
  switch ((code || "").trim()) {
    case "passkey_required":
      return reason || "Confirme a chave de acesso para concluir o pareamento do Channel.";
    case "err-scanned-without-multidevice":
      return "No celular, abra Channel > Aparelhos conectados > Conectar aparelho e escaneie o QR novamente.";
    case "timeout":
      return "O QR Code expirou antes do pareamento. Gere um novo QR Code e tente novamente.";
    case "err-client-outdated":
      return "O cliente do canal no servidor está desatualizado. Atualize o gateway de canais antes de parear.";
    case "err-unexpected-state":
      return "O pareamento entrou em um estado inesperado. Gere um novo QR Code e tente novamente.";
    default:
      return reason || null;
  }
};
